import React from 'react';
import { ListItem, IconButton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useState, useEffect } from 'react';
import { DEFAULT_LANGUAGE } from '../utils/localeUtils';
import { useTranslation } from 'react-i18next';

export default function SortableItemAttribute({
  item,
  removeAttribute,
  updateAttributeName,
  updateAttributeValue,
  selectedLanguage,
}) {
  const { t } = useTranslation();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab',
  };

  const [attributeValue, setAttributeValue] = useState({
    ro: item.attributeValue || '',
    en: item.attributeValue_en || '',
    de: item.attributeValue_de || '',
    hu: item.attributeValue_hu || '',
  });

  const [attributeName, setAttributeName] = useState({
    ro: item.attributeName || '',
    en: item.attributeName_en || '',
    de: item.attributeName_de || '',
    hu: item.attributeName_hu || '',
  });

  useEffect(() => {
    setAttributeValue({
      ro: item.attributeValue || '',
      en: item.attributeValue_en || '',
      de: item.attributeValue_de || '',
      hu: item.attributeValue_hu || '',
    });

    setAttributeName({
      ro: item.attributeName || '',
      en: item.attributeName_en || '',
      de: item.attributeName_de || '',
      hu: item.attributeName_hu || '',
    });
  }, [item]);

  const handleAttributeName = (e) => {
    const newValue = e.target.value;
    setAttributeName((prev) => ({
      ...prev,
      [selectedLanguage]: newValue,
    }));
    updateAttributeName(item.id, newValue, selectedLanguage);
  };

  const handleAttributeValue = (e) => {
    const newValue = e.target.value;
    setAttributeValue((prev) => ({
      ...prev,
      [selectedLanguage]: newValue,
    }));
    updateAttributeValue(item.id, newValue, selectedLanguage);
  };

  return (
    <ListItem ref={setNodeRef} style={style} divider>
      <DragIndicatorIcon {...attributes} {...listeners} sx={{ mr: 2, cursor: 'grab' }} />
      <Box>
        <TextField
          value={attributeName[selectedLanguage]}
          onChange={handleAttributeName}
          fullWidth
          variant="standard"
          margin="normal"
          size="small"
          placeholder={attributeName[DEFAULT_LANGUAGE]}
          name={item.attributeName}
          InputProps={{
            readOnly: selectedLanguage === DEFAULT_LANGUAGE,
          }}
        />
        <TextField
          value={attributeValue[selectedLanguage] ?? ''}
          onChange={handleAttributeValue}
          fullWidth
          variant="standard"
          margin="normal"
          size="small"
          name={item.attributeValue}
          placeholder={attributeValue[DEFAULT_LANGUAGE] || t('placeholderName')}
        />
      </Box>
      {selectedLanguage === DEFAULT_LANGUAGE && (
        <IconButton onClick={() => removeAttribute(item.id)} edge="end" aria-label="delete">
          <DeleteIcon />
        </IconButton>
      )}
    </ListItem>
  );
}
